import RecieveOrder from './RecieveOrder';
export default RecieveOrder;
